import { useParams } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import SkinTreatmentDetail from "@/pages/skin/components/SkinTreatmentDetail";
import { getSkinTreatment } from "@/mocks/skinTreatments";

export default function SkinTreatmentPage() {
  const { slug } = useParams<{ slug: string }>();
  const data = slug ? getSkinTreatment(slug) : undefined;
  if (!data) return <NotFound />;
  return <SkinTreatmentDetail data={data} />;
}